import pick from 'lodash/pick';
const noop = () => {};

export function LINEAR(from, to, passed, duration) {
    return from + (to - from) * (Math.min(passed, duration) / duration);
}


export function requestAnimationFramePolyFill(step) {
    setTimeout(
        () => {
            step(Date.now());
        }
        , 1000 / 60
    );
}

export function requestAnimationFrame(step) {
    let func = requestAnimationFramePolyFill;

    if (global.window && window.requestAnimationFrame) {
        func = window.requestAnimationFrame;
    }

    func(step);
}

export function transition(element, endValues, func, duration, done = noop) {
    const startValues = pick(element, Object.keys(endValues));
    let start = null;

    function step(timestamp) {
        if (!start) {
            start = timestamp;
        }

        Object.keys(endValues).forEach((key) => {
            if (startValues[key] !== undefined) {
                element[key] = func(startValues[key], endValues[key], timestamp - start, duration);
            }
        });

        if (timestamp - start < duration) {
            requestAnimationFrame(step);
        }
        else {
            done();
        }
    }

    requestAnimationFrame(step);
}
